import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/locationSitemap/pageContext';

export function LocationSitemapErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Local sitemap page (error: ${error})`);
}
